module.exports = __webpack_public_path__ + "static/img/good (3).146544d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/goods/good (3).jpg
// module id = 4ig2
// module chunks = 1